/**
 * Resolved application version injected at build time via the VITE_APP_VERSION
 * environment variable (format: YYYY.mm.dd.N, e.g. "2026.06.06.3").
 *
 * Falls back to "dev" in local development where the variable is not set.
 */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION || 'dev';
